import React, { useState, useContext, useMemo } from "react";
import { TextareaAutosize } from "@material-ui/core";
import * as actionTypes from "../../../redux/actionTypes";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert";
import { toast } from "react-toastify";
import moment from "moment";
import CommonDatePicker from "../../../myfin_v2/elements/CommonDatePicker";
import { useRef } from 'react';
import dayjs from "dayjs";
import MyDropdown from "../../../myfin_v2/elements/Dropdown";
import { ReactComponent as CalenderIcon } from "../../../myfin_v2/assets/icons/calender.svg";

import cross from "../../../assets/cross.svg";
import "../../../resource/style/extra.css";
import { Submit } from "../../../Components/Button";
import { socket } from "../../../services/socket/socket";
import {
  AccessProjectContext,
  ThemeContext,
} from "../../../helper/DarkModeContext";
import AddLedger from "../../../Components/addLedger/AddLedger";
import {
  fetchDeletedAdj,
  fetchSAAdjustment,
} from "../../../redux/actions/actionStandaloneAdj";
import { deleteAdjustment } from "../../../services/api/apiHandler";
import Loading from "../../../Components/Common/Loader/Loading";

import commoncss from "../../../myfin_v2/css/common.module.css";
import bookclosuretablecss from "../../../myfin_v2/css/bookclosuretable.module.css";
import wsCreationcss from "../../../myfin_v2/css/workspaceCreation.module.css";
import standalonecss from "../../../myfin_v2/css/standalone.module.css";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close_grey.svg";
import { ReactComponent as EditIcon } from "../../../myfin_v2/assets/icons/editPri.svg";
import { ReactComponent as DeleteIcon } from "../../../myfin_v2/assets/icons/delete_red.svg";
import { ReactComponent as DownArrowIcon } from "../../../myfin_v2/assets/icons/down_arrow.svg";
import DeletePopup from "../../../myfin_v2/elements/DeletePopup";
import Checkmark from "../../../myfin_v2/assets/icons/Check(circle).png";

const adjustmentsTable = {
  maxHeight: "71vh",
  overflow: "scroll",
  minHeight: "71vh",
  width: "100vw",
};

const formatFinanceNumber = (num) => {
  if (num === null || num === undefined || num === "") return "";
  const value = Number(num);
  if (isNaN(value)) return num;
  const formatted = new Intl.NumberFormat().format(Math.abs(value));
  return value < 0 ? `(${formatted})` : formatted;
};

const AdjustmentsTable = (props) => {
  const inputRefs = useRef({});
  const [isSaving, setIsSaving] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const { loading, adjustmentData, ledgerData, projectData } = props;

  const dispatch = useDispatch();
  const project_id = localStorage.getItem("project_id");
  const tb_id =
    useSelector((initialState) => initialState.reducer.tb_id) ||
    localStorage.getItem("tb_id");

  const [line, setLine] = useState([]);
  const [edit, setEdit] = useState(null);
  const [editval, setEditval] = useState(null);
  const [options, setOptions] = useState([]);
  const [remark, setRemark] = useState("");
  const [render, setRender] = useState("");
  const [value, setValue] = useState({});
  const [updateValue, setupdateValue] = useState("");
  const [pickerOpenId, setPickerOpenId] = useState(null);
  const [codeoptions, setCodeOptions] = useState([]);
  const [open, setOpen] = useState(false);
  const [select, setSelect] = useState({});
  const [isUpdate, setUpdate] = useState(false);
  const span = line.length;
  const { theme } = useContext(ThemeContext);
  const [deleteConfirmData, setDeleteConfirmData] = useState(null);

  const { access } = useContext(AccessProjectContext);

  useMemo(() => {
    ledgerData.map((val) => {
      setOptions((options) => [
        ...options,
        { value: val.lid, label: `${val.ledger_name}` },
      ]);

      setCodeOptions((codeoptions) => [
        ...codeoptions,
        {
          value: val.lid,
          label: `${val.ledger_code}`,
        },
      ]);
    });

    return () => {
      setOptions([]);
      setCodeOptions([]);
    };
  }, [ledgerData]);

  function handleSelect(e) {
    const label = e?.target?.textContent || e?.label;
    if (label) {
      ledgerData.map((tab) => {
        if (line.some((user) => user.lid === tab.lid)) {
          return;
        }
        if (tab.ledger_name === label) {
          const content = tab;
          content.isAdjusted = true;
          content.adjusted_amount = 0;
          setLine([...line, content]);
        }
      });
    }
  }

  function handleSelectcode(e) {
    const label = e?.target?.textContent || e?.label;
    if (label) {
      ledgerData.map((tab) => {
        if (line.some((user) => user.lid === tab.lid)) {
          return;
        }
        if (tab.ledger_code === label) {
          const content = tab;
          content.isAdjusted = true;
          content.adjusted_amount = 0;
          setLine([...line, content]);
        }
      });
    }
  }

  function handleChange(i, e, field) {
    if (field === "adjusted_amount") {
      let newLine = line;
      newLine[i].adjusted_amount = e.target.value;
      newLine[i].net_adjusted_amount = line[i].cy + Number(e.target.value);
      let val = Math.random();
      setLine(newLine);
      setEditval(val);
    }
  }

  function handlePost() {
    if (isSaving) return;
    setIsSaving(true);
    console.log("value", value);
    if (!value.date) {
      swal("", "Please select a date", "warning");
      setIsSaving(false);
      return;
    }
    const hasEmptyAdjustment = line.some((li) => {
      if (li.adjusted_amount === "" || li.adjusted_amount === 0) {
        swal("", "Adjustments can't be empty", "warning");
        return true; // Stops iteration and returns true if condition is met
      }
      return false;
    });
    if (hasEmptyAdjustment) {
      setIsSaving(false);
      return; // Prevents further execution
    }

    if (line.length === 0) {
      swal("", "Adjustments cant be empty", "warning");
      setIsSaving(false);
      return;
    }

    const sum = line.reduce(
      (totalpy, i) => totalpy + Number(i.adjusted_amount),
      0
    );
    if (sum == 0) {
      let ledger_items = [];
      adjustmentData.map((adj, i) => {
        var sortedKeys = Object.keys(adj).sort();
        var first = adj[sortedKeys[0]];
        first.map((val, ix) => {
          if (
            ledger_items.length > 0 &&
            ledger_items.some((user) => user.lid === val.lid)
          ) {
            let index1 = ledger_items.findIndex((x) => x.lid === val.lid);
            ledger_items[index1].adjusted_amount =
              Number(ledger_items[index1].adjusted_amount) +
              Number(val.adjusted_amount);
          } else {
            ledger_items.push({
              lid: val.lid,
              ledger_name: val.ledger_name,
              ledger_code: val.ledger_code,
              branch: val.branch,
              adjusted_amount: Number(val.adjusted_amount),
              cy: Number(val.cy),
            });
          }
        });
      });

      line.map((itm) => {
        if (
          ledger_items.length > 0 &&
          ledger_items.some((user) => user.lid === itm.lid)
        ) {
          let index1 = ledger_items.findIndex((x) => x.lid === itm.lid);
          ledger_items[index1].adjusted_amount =
            Number(ledger_items[index1].adjusted_amount) +
            Number(itm.adjusted_amount);
        } else {
          ledger_items.push({
            lid: itm.lid,
            ledger_name: itm.ledger_name,
            ledger_code: itm.ledger_code,
            branch: itm.branch,
            adjusted_amount: Number(itm.adjusted_amount),
            cy: Number(itm.cy),
          });
        }
      });
      const auth = localStorage.getItem("auth_token");
      let headers = { "x-auth-token": auth };
      const line_dat = line;
      const string = {};
      string.data = line_dat;
      string.remarks = remark;
      string.date = value.date;
      let stringAdjustment = JSON.stringify(string);
      let stringItems = JSON.stringify(ledger_items);
      const fd = new FormData();
      fd.append("adjustments", stringAdjustment);
      fd.append("ledger_items", stringItems);
      axios
        .post(
          `/api/v1/adjustments/save-adjustment-line-item/${project_id}/${tb_id}`,
          fd,
          { headers }
        )
        .then((res) => {
          dispatch(fetchSAAdjustment(project_id, tb_id));
          setLine([]);
          setRemark("");
          setValue({});
          socket.emit("request-conventional-mode", { project_id, tb_id });
          socket.emit("request-mapped-grouping", { project_id, tb_id });
          socket.emit("request-balance-sheet", { project_id, tb_id });
          socket.emit("request-pnl-statement", { project_id, tb_id });
          console.log("socket emit");
          setIsSaving(false);
          setSuccessMessage("Adjustment Created Successfully");
          setShowSuccessPopup(true);
          setTimeout(() => setShowSuccessPopup(false), 2000);
        })
        .catch((err) => {
          setRemark("");
          setValue({});
          dispatch(fetchSAAdjustment(project_id, tb_id));
          setLine([]);
          setIsSaving(false);
        });
    } else {
      swal("", "Adjustments sum should be 0", "warning");
      setIsSaving(false);
    }
  }

  const handleDelete = (item, index) => {
    setDeleteConfirmData({ item, index });
  };

  function handleEdit(i, first, value, date) {
    setEdit(i);
    setLine(first);
    setRemark(value);
    setupdateValue({ updatedate: date });
    props.setShowCreate(false);
    props.setEditOn(true);
  }

  const nf = new Intl.NumberFormat();

  function handleSaveEdit(id) {
    if (isSaving) return;
    setIsSaving(true);
    const hasEmptyAdjustment = line.some((li) => {
      if (li.adjusted_amount === "" || li.adjusted_amount === 0) {
        swal("", "Adjustments cant be empty", "warning");
        return true;
      }
      return false;
    });
    if (hasEmptyAdjustment) {
      setIsSaving(false);
      return;
    }
    if (line.length === 0) {
      swal("", "Adjustments cant be empty", "warning");
      setIsSaving(false);
      return;
    }
    const sum = line.reduce(
      (totalpy, i) => totalpy + Number(i.adjusted_amount),
      0
    );
    if (sum == 0) {
      const value = id[0];
      let ledger_items = [];
      adjustmentData.map((adj, i) => {
        var sortedKeys = Object.keys(adj).sort();
        var first = adj[sortedKeys[0]];
        first.map((val, ix) => {
          if (
            ledger_items.length > 0 &&
            ledger_items.some((user) => user.lid === val.lid)
          ) {
            let index1 = ledger_items.findIndex((x) => x.lid === val.lid);
            ledger_items[index1].adjusted_amount =
              Number(ledger_items[index1].adjusted_amount) +
              Number(val.adjusted_amount);
          } else {
            ledger_items.push({
              lid: val.lid,
              ledger_name: val.ledger_name,
              ledger_code: val.ledger_code,
              branch: val.branch,
              adjusted_amount: Number(val.adjusted_amount),
              cy: Number(val.cy),
            });
          }
        });
      });

      const auth = localStorage.getItem("auth_token");
      let headers = { "x-auth-token": auth };
      const string = {};
      string.data = line;
      string.remarks = remark;
      string.date = updateValue.updatedate;
      let stringAdjustment = JSON.stringify(string);
      let stringItems = JSON.stringify(ledger_items);
      const fd = new FormData();
      fd.append("adjustment", stringAdjustment);
      fd.append("ledger_items", stringItems);
      axios
        .post(
          `/api/v1/adjustments/edit-adjustment/${project_id}/${tb_id}/${value}`,
          fd,
          { headers }
        )
        .then((res) => {
          setEdit(null);
          props.setEditOn(false);
          props.setShowCreate(false);
          dispatch(fetchSAAdjustment(project_id, tb_id));

          setLine([]);
          setRemark("");
          setValue({});

          socket.emit("request-conventional-mode", { project_id, tb_id });
          socket.emit("request-mapped-grouping", { project_id, tb_id });
          socket.emit("request-pnl-statement", { project_id, tb_id });
          setIsSaving(false);
          setSuccessMessage("Adjustment Saved Successfully");
          setShowSuccessPopup(true);
          setTimeout(() => setShowSuccessPopup(false), 2000);
        })
        .catch((err) => {
          dispatch(fetchSAAdjustment(project_id, tb_id));
          props.setShowCreate(false);
          props.setEditOn(false);
          setLine([]);
          setRemark("");
          setValue({});
          setIsSaving(false);
        });
    } else {
      swal("", "Adjustments sum should be 0", "warning");
      setIsSaving(false);
    }
  }

  function handleCancel() {
    setEdit(null);
    setLine([]);
    props.setShowCreate(false);
    props.setEditOn(false);
  }

  const parseDDMMYYYY = (str) => {
    if (!str) return null;
    const parts = str.split(/\D+/).map((p) => p.trim());
    if (parts.length < 3) return null;
    const dd = parseInt(parts[0], 10);
    const mm = parseInt(parts[1], 10);
    const yyyy = parseInt(parts[2], 10);
    if (isNaN(dd) || isNaN(mm) || isNaN(yyyy)) return null;
    const date = new Date(yyyy, mm - 1, dd);
    if (date && date.getDate() === dd && date.getMonth() === mm - 1 && date.getFullYear() === yyyy) return date;
    return null;
  };

  function handleAddOption() {
    setOpen(true);
  }

  function handleRemark(e) {
    setRemark(e.target.value);
  }

  function handleDrop(i) {
    var arr1 = line;
    delete arr1[i];
    var arr2 = line.splice(i, 1);
    // const result = line.filter((row,ix) => ix !== i )
    setLine(arr1);
    setRender(Math.random());
  }

  const showActionsColumn = (adjustmentData && adjustmentData.length > 0) || (edit !== null) || (props.showCreate && line.length > 0);

  return (
    <React.Fragment>
      {open && (
        <AddLedger
          close={setOpen}
          name="Add Ledger Below"
          select={select}
          tb_id={tb_id}
          setUpdate={setUpdate}
        />
      )}

      <div
        className={`${bookclosuretablecss.bookClosureTableContainer} ${commoncss.hideScroll}`}
        style={{ overflow: "auto", height: "88vh",border: "1px solid #dddddd",borderRadius: "10px", backgroundColor: "#fff", marginLeft: "20px", marginTop: "5px", width: "calc(100% - 40px)" }}
      >
        {loading ? (
          <Loading />
        ) : (
          <table
            // className={`${access.access === "View" ? "disabled-table" : ""}`}
            className={`${bookclosuretablecss.bookClosureTable} ${bookclosuretablecss.bookclosureEntries} ${commoncss.hideScroll} ${bookclosuretablecss.adjTable}`}
            style = {{ border: "none" }}
          >
            <thead>
              <tr>
                <th
                  className="text-center"
                  style={{
                    width: "70px",
                    minWidth: "70px",
                  }}
                >
                  S NO
                </th>
                <th
                  className="text-left "
                  style={{
                    minWidth: "120px",
                  }}
                >
                  EFFECTIVE DATE
                </th>
                <th className="text-left " style={{ width: "150px", minWidth: "150px" }}>
                  LEDGER CODE
                </th>
                <th className="text-left " style={{ minWidth: "650px" }}>
                  LEDGER NAME
                </th>
                <th className="text-left " style={{ minWidth: "100px" }}>
                  BRANCH
                </th>
                <th
                  className="text-right "
                  style={{
                    minWidth: "120px",
                  }}
                >
                  CURRENT YEAR
                </th>
                <th className="text-right " style={{ minWidth: "120px" }}>
                  ADJUSTMENT VALUE
                </th>
                <th className="text-left " style={{ minWidth: "250px" }}>
                  REMARKS
                </th>
                {showActionsColumn && (
                  <th
                    className="text-left "
                    style={{
                      width: "180px",
                      minWidth: "180px",
                    }}
                  ></th>
                )}
              </tr>
            </thead>

            <tbody>
              {adjustmentData?.length > 0 &&
                adjustmentData.map((adj, i) => {
                  var sortedKeys = Object.keys(adj).sort();
                  var first = adj[sortedKeys[0]];
                  if (i == edit) {
                    return (
                      <>
                        {line.map((lines, idx) => {
                          if (idx === 0) {
                            return (
                              <tr key={idx} className={idx === 0 ? bookclosuretablecss.adjGroupRow : ""}>
                                <td
                                  style={{ textAlign: "center", verticalAlign: "middle", width: "70px" }}
                                  rowSpan={span + 1}
                                >
                                  {i + 1}
                                </td>
                                <td
                                  style={{ textAlign: "left" }}
                                  rowSpan={span + 1}
                                >
                                  <CommonDatePicker
                                    value={updateValue.updatedate}
                                    onChange={(date) => {
                                      setupdateValue({
                                        ...updateValue,
                                        ["updatedate"]: date,
                                      });
                                    }}
                                    inputStyle={{ padding: 0, margin: 0 }}
                                    containerStyle={{ height: "37px", minHeight: "37px", maxHeight: "37px" }}
                                  />
                                </td>
                                <td
                                  className={commoncss.adjCellHover}
                                  style={{
                                    textAlign: "left",
                                    width: "150px",
                                    minWidth: "150px",
                                  }}
                                >
                                  <div className={`${commoncss.adjBox} w-100`}>
                                    <span>{lines.ledger_code || <span className={commoncss.adjPlaceholderText}>Select Code</span>}</span>
                                    <DownArrowIcon width={12} />
                                  </div>
                                </td>
                                <td
                                  className={commoncss.adjCellHover}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div className={commoncss.adjBox} title={lines.ledger_name || "Select Name"}>
                                    <div 
                                      title={lines.ledger_name || "Select Name"}
                                      style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", wordBreak: "keep-all" }}
                                    >
                                      {lines.ledger_name || <span className={commoncss.adjPlaceholderText}>Select Name</span>}
                                    </div>
                                      <CloseIcon
                                        className={commoncss.clickable}
                                        onClick={() => {
                                          handleDrop(idx);
                                        }}
                                      />
                                  </div>
                                </td>
                                <td className={commoncss.adjCellHover} style={{ textAlign: "left" }}>
                                  <div className={commoncss.adjBoxTransparent}>
                                    <span>{lines.branch || <span className={commoncss.adjPlaceholderText}>Auto-Populated</span>}</span>
                                  </div>
                                </td>
                                  <td
                                    className={commoncss.adjCellHover}
                                    style={{
                                      textAlign: "right",
                                    }}
                                  >
                                    <div className={commoncss.adjBoxTransparent} style={{ justifyContent: "flex-end" }}>
                                      <span style={{ textAlign: "right", width: "100%" }}>{formatFinanceNumber(lines.cy) === "" ? <span className={commoncss.adjPlaceholderText}>Auto-Populated</span> : formatFinanceNumber(lines.cy)}</span>
                                    </div>
                                  </td>
                                <td className={commoncss.adjCellHover} style={{ textAlign: "right" }}>
                                  <div className={commoncss.adjBoxTransparent} style={{ justifyContent: "flex-end" }}>
                                      <input
                                        type="number"
                                        value={lines.adjusted_amount}
                                        placeholder="Enter Amount"
                                        onChange={(e) => {
                                          handleChange(idx, e, "adjusted_amount");
                                        }}
                                      style={{
                                        border: "none",
                                        textAlign: "right",
                                        background: "transparent",
                                        outline: "none",
                                        width: "100%",
                                        fontSize: "inherit",
                                        fontFamily: "inherit",
                                        padding: 0,
                                        margin: 0
                                      }}
                                    />
                                  </div>
                                </td>
                                <td
                                  className={commoncss.adjCellHover}
                                  style={{ textAlign: "left" }}
                                  rowSpan={span + 1}
                                >
                                  {line.length === 0 ? null : (
                                    <div className={commoncss.adjBoxTransparent} style={{ height: "100%", alignItems: "flex-start", padding: "8px 10px" }}>
                                      <TextareaAutosize
                                        style={{
                                          width: "100%",
                                          border: "none",
                                          background: "transparent",
                                          outline: "none",
                                          fontSize: "inherit",
                                          fontFamily: "inherit",
                                          resize: "none",
                                        }}
                                        aria-label="maximum height"
                                        value={remark}
                                        onChange={(e) => {
                                          handleRemark(e);
                                        }}
                                        maxRows={line.length}
                                        placeholder="Enter your remarks here"
                                      />
                                    </div>
                                  )}
                                </td>
                                <td
                                  className={commoncss.adjCellHover}
                                  style={{ textAlign: "left", verticalAlign: "middle" }}
                                  rowSpan={span + 1}
                                >
                                  {line.length === 0 ? null : (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        gap: "12px",
                                        alignItems: "center",
                                      }}
                                    >
                                      <span
                                        className={`${commoncss.label3} ${commoncss.clrGreen}`}
                                        style={{ cursor: "pointer", fontWeight: "600", whiteSpace: "nowrap" }}
                                        onClick={() => {
                                          handleCancel();
                                        }}
                                      >
                                        Cancel
                                      </span>
                                      <button
                                        className={wsCreationcss.saveBtn}
                                        type="button"
                                        onClick={() => {
                                          handleSaveEdit(sortedKeys);
                                        }}
                                        style={{ padding: "6px 16px", borderRadius: "6px", fontWeight: "600", opacity: isSaving ? 0.6 : 1 }} disabled={isSaving}
                                      >
                                        {isSaving ? "Saving..." : "Save"}
                                      </button>
                                    </div>
                                  )}
                                </td>
                              </tr>
                            );
                          }
                          return (
                            <tr key={idx} className={idx === 0 ? bookclosuretablecss.adjGroupRow : ""}>
                              <td className={commoncss.adjCellHover} style={{ textAlign: "left", width: "150px", minWidth: "150px" }}>
                                <div className={`${commoncss.adjBox} w-100`}>
                                  <span>{lines.ledger_code}</span>
                                  <DownArrowIcon width={12} />
                                </div>
                              </td>
                              <td
                                className={commoncss.adjCellHover}
                                style={{
                                  textAlign: "left",
                                }}
                              >
                                <div className={commoncss.adjBox} title={lines.ledger_name || "Select Name"}>
                                  <div 
                                    title={lines.ledger_name || "Select Name"}
                                    style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", wordBreak: "keep-all" }}
                                  >
                                    {lines.ledger_name || <span className={commoncss.adjPlaceholderText}>Select Name</span>}
                                  </div>
                                  <CloseIcon
                                    className={commoncss.clickable}
                                    onClick={() => {
                                      handleDrop(idx);
                                    }}
                                  />
                                </div>
                              </td>
                              <td className={commoncss.adjCellHover} style={{ textAlign: "left" }}>
                                <div className={commoncss.adjBoxTransparent}>
                                  <span>{lines.branch || <span className={commoncss.adjPlaceholderText}>Auto-Populated</span>}</span>
                                </div>
                              </td>
                              <td
                                className={commoncss.adjCellHover}
                                style={{
                                  textAlign: "right",
                                }}
                              >
                                <div className={commoncss.adjBoxTransparent} style={{ justifyContent: "flex-end" }}>
                                  <span style={{ textAlign: "right", width: "100%" }}>{lines.cy ? formatFinanceNumber(lines.cy) : <span className={commoncss.adjPlaceholderText}>Auto-Populated</span>}</span>
                                </div>
                              </td>
                              <td className={commoncss.adjCellHover} style={{ textAlign: "right" }}>
                                <div className={commoncss.adjBoxTransparent} style={{ justifyContent: "flex-end" }}>
                                  <input
                                    type="number"
                                    value={lines.adjusted_amount}
                                    placeholder="Enter Amount"
                                    onChange={(e) => {
                                      handleChange(idx, e, "adjusted_amount");
                                    }}
                                    style={{
                                      border: "none",
                                      textAlign: "right",
                                      background: "transparent",
                                      outline: "none",
                                      width: "100%",
                                      fontSize: "inherit",
                                      fontFamily: "inherit",
                                    }}
                                  />
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                        <tr
                          style={{
                            background: `${theme ? "" : "#363535"}`,
                          }}
                        >
                          <td style={{ textAlign: "left", width: "150px", minWidth: "150px" }}>
                            <MyDropdown
                              key={`code-select-${line.length}`}
                              options={codeoptions}
                              onSelect={handleSelectcode}
                              placeHolder="Select Code"
                              class_={bookclosuretablecss.adjDropdown}
                              class2_={bookclosuretablecss.adjDropdownInner}
                            />
                          </td>

                          <td
                            style={{
                              textAlign: "left",
                              color: "black",
                            }}
                          >
                            <MyDropdown
                              key={`name-select-${line.length}`}
                              options={options}
                              onSelect={handleSelect}
                              placeHolder="Select Name"
                              class_={bookclosuretablecss.adjDropdown}
                              class2_={bookclosuretablecss.adjDropdownInner}
                            />
                          </td>
                          <td style={{ textAlign: "left" }}></td>
                          <td style={{ textAlign: "left" }}></td>
                          <td style={{ textAlign: "left" }}></td>
                        </tr>
                      </>
                    );
                  }

                  return first.map((val, ix) => {
                    const inx = first.length;
                    const height = inx * 45 - 10;
                    const value = adj["remarks"];
                    const date = adj["date"];
                    if (ix === 0) {
                      return (
                        <tr
                          style={{
                            background: `${theme ? "" : "#363535"}`,
                          }}
                          key={ix}
                        >
                          <td
                            className={commoncss.adjCellHover}
                            style={{ textAlign: "center", verticalAlign: "middle", width: "70px" }}
                            rowSpan={first.length}
                          >
                            {i + 1}
                          </td>
                          <td
                            className={commoncss.adjCellHover}
                            style={{ textAlign: "left", padding: "10px" }}
                            rowSpan={first.length}
                          >
                            <div className={commoncss.adjBox}>
                              <span>{moment(date).format("DD-MM-YYYY")}</span>
                              <CalenderIcon width={20} height={20} />
                            </div>
                          </td>
                          <td className={commoncss.adjCellHover} style={{ textAlign: "left", width: "150px", minWidth: "150px" }}>
                            <div className={`${commoncss.adjBox} w-100`}>
                              <span>{val.ledger_code || <span className={commoncss.adjPlaceholderText}>Select Code</span>}</span>
                              <DownArrowIcon width={12} />
                            </div>
                          </td>
                          <td
                            className={commoncss.adjCellHover}
                            style={{
                              textAlign: "left",
                              height: "auto",
                            }}
                          >
                            <div className={commoncss.adjBox} title={val.ledger_name || "Select Name"}>
                              <span title={val.ledger_name || "Select Name"} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", wordBreak: "keep-all" }}>{val.ledger_name || <span className={commoncss.adjPlaceholderText}>Select Name</span>}</span>
                              <DownArrowIcon width={12} />
                            </div>
                          </td>
                          <td className={commoncss.adjCellHover} style={{ textAlign: "left" }}>
                            <div className={commoncss.adjBoxTransparent}>
                              <span>{val.branch || <span className={commoncss.adjPlaceholderText}>Auto-Populated</span>}</span>
                            </div>
                          </td>
                          <td
                            className={commoncss.adjCellHover}
                            style={{
                              textAlign: "right",
                            }}
                          >
                            <div className={commoncss.adjBoxTransparent} style={{ justifyContent: "flex-end" }}>
                              <span style={{ textAlign: "right", width: "100%" }}>{val.cy ? formatFinanceNumber(val.cy) : <span className={commoncss.adjPlaceholderText}>Auto-Populated</span>}</span>
                            </div>
                          </td>
                          <td
                            className={commoncss.adjCellHover}
                            style={{
                              textAlign: "right",
                            }}
                          >
                            <div className={commoncss.adjBoxTransparent} style={{ justifyContent: "flex-end" }}>
                              <span style={{ textAlign: "right", width: "100%" }}>{val.adjusted_amount ? formatFinanceNumber(val.adjusted_amount) : <span className={commoncss.adjPlaceholderText}>Enter Amount</span>}</span>
                            </div>
                          </td>
                          <td
                             className={commoncss.adjCellHover}
                             style={{ textAlign: "left" }}
                             rowSpan={first.length}
                           >
                             <div
                                className={commoncss.adjBoxTransparent}
                                style={{
                                  maxHeight: `${height}px`,
                                  overflowY: "auto",
                                }}
                              >
                                 {value || <span className={commoncss.adjPlaceholderText}>Enter Remarks</span>}
                              </div>
                           </td>
                          <td className="text-center" rowSpan={first.length}>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "20px" }}>
                              <EditIcon
                                className={commoncss.clickable}
                                onClick={() => {
                                  handleEdit(i, first, value, date);
                                }}
                              />
                              <DeleteIcon
                                className={commoncss.clickable}
                                onClick={() => {
                                  handleDelete(adj, i);
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    } else {
                      return (
                          <tr
                            style={{
                              background: `${theme ? "" : "#363535"}`,
                            }}
                            key={ix}
                            className={ix === 0 ? bookclosuretablecss.adjGroupRow : ""}
                          >
                          <td className={commoncss.adjCellHover} style={{ textAlign: "left", width: "150px", minWidth: "150px" }}>
                            <div className={`${commoncss.adjBox} w-100`}>
                              <span>{val.ledger_code || <span className={commoncss.adjPlaceholderText}>Select Code</span>}</span>
                              <DownArrowIcon width={12} />
                            </div>
                          </td>
                          <td
                            className={commoncss.adjCellHover}
                            style={{
                              textAlign: "left",
                              height: "auto",
                            }}
                          >
                            <div className={commoncss.adjBox} title={val.ledger_name || "Select Name"}>
                              <span title={val.ledger_name || "Select Name"} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", wordBreak: "keep-all" }}>{val.ledger_name || <span className={commoncss.adjPlaceholderText}>Select Name</span>}</span>
                              <DownArrowIcon width={12} />
                            </div>
                          </td>
                          <td className={commoncss.adjCellHover} style={{ textAlign: "left" }}>
                            <div className={commoncss.adjBoxTransparent}>
                              <span>{val.branch || <span className={commoncss.adjPlaceholderText}>Auto-Populated</span>}</span>
                            </div>
                          </td>
                          <td
                            className={commoncss.adjCellHover}
                            style={{
                              textAlign: "right",
                              verticalAlign: "middle",
                            }}
                          >
                            <div className={commoncss.adjBoxTransparent} style={{ justifyContent: "flex-end" }}>
                              <span style={{ textAlign: "right", width: "100%" }}>{val.cy ? formatFinanceNumber(val.cy) : <span className={commoncss.adjPlaceholderText}>Auto-Populated</span>}</span>
                            </div>
                          </td>
                          <td
                            className={commoncss.adjCellHover}
                            style={{
                              textAlign: "right",
                              verticalAlign: "middle",
                            }}
                          >
                            <div className={commoncss.adjBoxTransparent} style={{ justifyContent: "flex-end" }}>
                              <span style={{ textAlign: "right", width: "100%" }}>{val.adjusted_amount ? formatFinanceNumber(val.adjusted_amount) : <span className={commoncss.adjPlaceholderText}>Enter Amount</span>}</span>
                            </div>
                          </td>
                        </tr>
                      );
                    }
                  });
                })}

              {props.showCreate && line.length > 0 && (
                <>
                  {props.showCreate &&
                    line.map((lines, i) => {
                      if (i === 0) {
                        return (
                          <tr
                            style={{
                              background: `${theme ? "" : "#363535"}`,
                            }}
                            key={i}
                            className={i === 0 ? bookclosuretablecss.adjGroupRow : ""}
                          >
                            <td
                              style={{ textAlign: "center", verticalAlign: "middle", width: "70px" }}
                              rowSpan={span + 1}
                            >
                              {adjustmentData.length + 1}
                            </td>
                             <td
                               style={{ textAlign: "left" }}
                               rowSpan={span + 1}
                             >
                                <CommonDatePicker
                                  value={value.date}
                                  onChange={(date) => {
                                    setValue({ ...value, ["date"]: date });
                                  }}
                                  containerStyle={{ height: "37px" }}
                                />
                             </td>
                             <td className={commoncss.adjCellHover} style={{ textAlign: "left", width: "150px", minWidth: "150px" }}>
                               <div className={`${commoncss.adjBox} w-100`}>
                                 <span>{lines.ledger_code || <span className={commoncss.adjPlaceholderText}>Select Code</span>}</span>
                                 <DownArrowIcon width={12} />
                               </div>
                             </td>
                             <td
                               className={commoncss.adjCellHover}
                               style={{
                                 textAlign: "left",
                                 height: "auto",
                               }}
                             >
                               <div className={commoncss.adjBox} title={lines.ledger_name || "Select Name"}>
                                 <div title={lines.ledger_name || "Select Name"} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", wordBreak: "keep-all" }}>{lines.ledger_name || <span className={commoncss.adjPlaceholderText}>Select Name</span>}</div>
                                 <CloseIcon
                                   className={commoncss.clickable}
                                   onClick={() => {
                                     handleDrop(i);
                                   }}
                                 />
                               </div>
                             </td>
                              <td className={commoncss.adjCellHover} style={{ textAlign: "left" }}>
                                <div className={commoncss.adjBoxTransparent}>
                                  <span>{lines.branch || <span className={commoncss.adjPlaceholderText}>Auto-Populated</span>}</span>
                                </div>
                              </td>
                              <td
                                className={commoncss.adjCellHover}
                                style={{
                                  textAlign: "right",
                                }}
                              >
                                <div className={commoncss.adjBoxTransparent} style={{ justifyContent: "flex-end" }}>
                                  <span style={{ textAlign: "right", width: "100%" }}>{lines.cy ? formatFinanceNumber(lines.cy) : <span className={commoncss.adjPlaceholderText}>Auto-Populated</span>}</span>
                                </div>
                              </td>
                              <td className={commoncss.adjCellHover} style={{ textAlign: "right" }}>
                                <div className={commoncss.adjBoxTransparent} style={{ justifyContent: "flex-end" }}>
                                  <input
                                    type="number"
                                    placeholder="Enter Amount"
                                    onChange={(e) => {
                                      handleChange(i, e, "adjusted_amount");
                                    }}
                                    style={{
                                      border: "none",
                                      textAlign: "right",
                                      background: "transparent",
                                      outline: "none",
                                      width: "100%",
                                    }}
                                  />
                                </div>
                              </td>
                            <td
                              className={commoncss.adjCellHover}
                              style={{ textAlign: "left" }}
                              rowSpan={span + 1}
                            >
                              {line.length === 0 ? null : (
                                <div className={commoncss.adjBoxTransparent} style={{ height: "100%", alignItems: "flex-start", padding: "8px 10px" }}>
                                  <TextareaAutosize
                                    style={{
                                      width: "100%",
                                      border: "none",
                                      background: "transparent",
                                      outline: "none",
                                      fontSize: "inherit",
                                      fontFamily: "inherit",
                                      resize: "none",
                                    }}
                                    aria-label="maximum height"
                                    maxRows={3}
                                    value={remark}
                                    onChange={(e) => {
                                      handleRemark(e);
                                    }}
                                    placeholder="Enter your remarks here"
                                  />
                                </div>
                              )}
                            </td>
                             <td
                               className={commoncss.adjCellHover}
                               style={{ textAlign: "left", verticalAlign: "middle" }}
                               rowSpan={span + 1}
                             >
                               {line.length === 0 ? null : (
                                 <div
                                   style={{
                                     display: "flex",
                                     justifyContent: "center",
                                     gap: "12px",
                                     alignItems: "center",
                                   }}
                                 >
                                   <div>
                                     <span
                                       onClick={() => {
                                         handleCancel();
                                       }}
                                       style={{
                                         cursor: "pointer",
                                         color: "#183930",
                                         fontWeight: "600",
                                         fontSize: "14px",
                                         whiteSpace: "nowrap"
                                        // marginLeft: "24px"
                                       }}
                                     >
                                       Cancel
                                     </span>
                                   </div>
                                   <div>
                                     <button
                                       className={wsCreationcss.saveBtn}
                                       type="button"
                                       disabled={isSaving}
                                       onClick={() => {
                                         handlePost();
                                       }}
                                       style={{ padding: "4px 12px", borderRadius: "6px", fontWeight: "600", opacity: isSaving ? 0.6 : 1 }}
                                     >
                                       {isSaving ? "Saving..." : "Save"}
                                     </button>
                                   </div>
                                 </div>
                               )}
                             </td>
                          </tr>
                        );
                      }
                      return (
                        <tr
                          style={{
                            background: `${theme ? "" : "#363535"}`,
                          }}
                          className={i === 0 ? bookclosuretablecss.adjGroupRow : ""}
                          key={i}
                        >
                              <td className={commoncss.adjCellHover} style={{ textAlign: "left", width: "150px", minWidth: "150px" }}>
                                <div className={`${commoncss.adjBox} w-100`}>
                                  <span>{lines.ledger_code || <span className={commoncss.adjPlaceholderText}>Select Code</span>}</span>
                                  <DownArrowIcon width={12} />
                                </div>
                              </td>

                          <td
                            className={commoncss.adjCellHover}
                            style={{
                              textAlign: "left",
                            }}
                          >
                            <div className={commoncss.adjBox} title={lines.ledger_name || "Select Name"}>
                              <div title={lines.ledger_name || "Select Name"} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", wordBreak: "keep-all" }}>{lines.ledger_name || <span className={commoncss.adjPlaceholderText}>Select Name</span>}</div>
                              <CloseIcon
                                className={commoncss.clickable}
                                onClick={() => {
                                  handleDrop(i);
                                }}
                              />
                            </div>
                          </td>
                          <td className={commoncss.adjCellHover} style={{ textAlign: "left" }}>
                            <div className={commoncss.adjBoxTransparent}>
                              <span>{lines.branch || <span className={commoncss.adjPlaceholderText}>Auto-Populated</span>}</span>
                            </div>
                          </td>
                          <td
                            className={commoncss.adjCellHover}
                            style={{
                              textAlign: "right",
                              verticalAlign: "middle",
                            }}
                          >
                            <div className={commoncss.adjBoxTransparent} style={{ justifyContent: "flex-end" }}>
                              <span style={{ textAlign: "right", width: "100%" }}>{lines.cy ? formatFinanceNumber(lines.cy) : <span className={commoncss.adjPlaceholderText}>Auto-Populated</span>}</span>
                            </div>
                          </td>
                          <td className={commoncss.adjCellHover} style={{ textAlign: "right", verticalAlign: "middle" }}>
                            <div className={commoncss.adjBoxTransparent} style={{ justifyContent: "flex-end" }}>
                              <input
                                type="number"
                                placeholder="Enter Amount"
                                onChange={(e) => {
                                  handleChange(i, e, "adjusted_amount");
                                }}
                                style={{
                                  maxWidth: "140px",
                                  border: "none",
                                  textAlign: "right",
                                  background: "transparent",
                                  outline: "none",
                                  width: "100%",
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  <tr>
                    <td style={{ textAlign: "left", width: "150px", minWidth: "150px" }}>
                      <MyDropdown
                        key={`code-select-${line.length}`}
                        options={codeoptions}
                        onSelect={handleSelectcode}
                        placeHolder="Select Code"
                        class_={bookclosuretablecss.adjDropdown}
                        class2_={bookclosuretablecss.adjDropdownInner}
                      />
                    </td>
                    <td style={{ textAlign: "left" }}>
                      <MyDropdown
                        key={`name-select-${line.length}`}
                        options={options}
                        onSelect={handleSelect}
                        placeHolder="Select Name"
                        class_={bookclosuretablecss.adjDropdown}
                        class2_={bookclosuretablecss.adjDropdownInner}
                      />
                    </td>
                    <td style={{ textAlign: "left" }}>
                      <div className={commoncss.adjBoxTransparent}>
                        <span className={commoncss.adjPlaceholderText}>Auto-Populated</span>
                      </div>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <div className={commoncss.adjBoxTransparent} style={{ justifyContent: "flex-end" }}>
                        <span className={commoncss.adjPlaceholderText}>Auto-Populated</span>
                      </div>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <div className={commoncss.adjBoxTransparent} style={{ justifyContent: "flex-end" }}>
                        <span className={commoncss.adjPlaceholderText}>Enter Amount</span>
                      </div>
                    </td>
                  </tr>
                </>
              )}
              {props.showCreate && line.length === 0 && (
                <>
                  <tr>
                    <td style={{ textAlign: "center", width: "70px" }}>{adjustmentData.length + 1}</td>
                    <td style={{ textAlign: "left" }}>
                      <CommonDatePicker
                        value={value.date}
                        onChange={(date) => {
                          setValue({ ...value, ["date"]: date });
                        }}
                        containerStyle={{ height: "37px" }}
                      />
                    </td>
                    <td style={{ textAlign: "left", width: "150px", minWidth: "150px" }}>
                      <MyDropdown
                        key={`code-select-${line.length}`}
                        options={codeoptions}
                        onSelect={handleSelectcode}
                        placeHolder="Select Code"
                        class_={bookclosuretablecss.adjDropdown}
                        class2_={bookclosuretablecss.adjDropdownInner}
                      />
                    </td>
                    <td style={{ textAlign: "left" }}>
                      <MyDropdown
                        key={`name-select-${line.length}`}
                        options={options}
                        onSelect={handleSelect}
                        placeHolder="Select Name"
                        class_={bookclosuretablecss.adjDropdown}
                        class2_={bookclosuretablecss.adjDropdownInner}
                      />
                    </td>
                    <td style={{ textAlign: "left" }}>
                      <div className={commoncss.adjBoxTransparent}>
                        <span className={commoncss.adjPlaceholderText}>Auto-Populated</span>
                      </div>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <div className={commoncss.adjBoxTransparent} style={{ justifyContent: "flex-end" }}>
                        <span className={commoncss.adjPlaceholderText}>Auto-Populated</span>
                      </div>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <div className={commoncss.adjBoxTransparent} style={{ justifyContent: "flex-end" }}>
                        <span className={commoncss.adjPlaceholderText}>Enter Amount</span>
                      </div>
                    </td>
                    <td style={{ textAlign: "left" }}>
                      <div className={commoncss.adjBoxTransparent}>
                        <span className={commoncss.adjPlaceholderText}>Enter Remarks</span>
                      </div>
                    </td>
                    {showActionsColumn && <td style={{ textAlign: "center", verticalAlign: "top" }}></td>}
                  </tr>
                </>
              )}
            </tbody>
          </table>
        )}
        {adjustmentData?.length <= 0 && line.length === 0 && (
          <p className="w-100 text-center text-secondary">
            Adjustment data is empty.
          </p>
        )}
      </div>
      <DeletePopup
        isOpen={deleteConfirmData !== null}
        title={<>Do you want to <span style={{ fontWeight: 700 }}>delete</span> selected adjustment?</>}
        message="Once deleted, you can restore using the bin"
        onConfirm={() => {
          if (!deleteConfirmData) return;
          const { item, index } = deleteConfirmData;
          setDeleteConfirmData(null);
          
          deleteAdjustment(project_id, tb_id, { item, index })
            .then((response) => {
              setSuccessMessage("Deleted successfully");
              setShowSuccessPopup(true);
              setTimeout(() => setShowSuccessPopup(false), 2000);
              dispatch(fetchSAAdjustment(project_id, tb_id));
              dispatch(fetchDeletedAdj(project_id, tb_id));
              socket.emit("request-conventional-mode", { project_id, tb_id });
              socket.emit("request-mapped-grouping", { project_id, tb_id });
              socket.emit("request-balance-sheet", { project_id, tb_id });
              socket.emit("request-pnl-statement", { project_id, tb_id });
            })
            .catch((error) => {
              swal(
                "Error",
                error.response?.data?.error || "Internal Server Error",
                "error"
              );
            });
        }}
        onCancel={() => setDeleteConfirmData(null)}
      />
      {showSuccessPopup && (
        <div className={commoncss.overlay} style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 99999 }}>
          <div className={commoncss.popup} style={{ width: "380px", height: "245px"}}>
            <div className={commoncss.iconWrapper} >
              <img src={Checkmark} alt="Success" width={90} height={90} />
            </div>
            <p className={commoncss.restoreText}>{successMessage}</p>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default AdjustmentsTable;
